import asyncActionTypes from '../actions/types.js';

const initialState = {
  priorityList: false,
  loadingPriorityList: false,
  priorityListSuccess: false,
  priorityListFail: false,
};

const priorityList = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.MANAGE_RETRIEVE_PRIORITY_LIST.START:
      return {
        ...state,
        loadingPriorityList: true,
      };
    case asyncActionTypes.MANAGE_RETRIEVE_PRIORITY_LIST.SUCCESS:
      return {
        ...state,
        loadingPriorityList: false,
        priorityList: action.payload.response,
        priorityListSuccess: true,
      };
    case asyncActionTypes.MANAGE_RETRIEVE_PRIORITY_LIST.FAIL:
      return {
        ...state,
        loadingPriorityList: false,
        priorityList: action.payload,
        priorityListFail: true,
      };
    default:
      return state;
  }
};

export default priorityList;
